import React from 'react'
import Lottie from 'lottie-react'
import pagenotavailable from '../assests/animation/pagenotfound.json'
export default function pagenotfound() {
  return (
   <>
    
   <Lottie animationData={pagenotavailable}/>
   
   </>
  )
}
